// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM11 9.0397L7.61869 7.1377L6.63816 8.88084L8.45917 9.90517L6.60001 11.2995L7.80001 12.8995L11 10.4995L11 9.0397ZM15.5408 9.90516L17.3618 8.88084L16.3813 7.1377L13 9.0397L13 10.4995L16.2 12.8995L17.4 11.2995L15.5408 9.90516ZM8.5 16.4995C8.5 15.9472 8.9477 15.4995 9.5 15.4995C9.76708 15.4995 10.0079 15.6029 10.188 15.7738C10.5103 16.0796 11.0664 16.4995 11.8092 16.4995H12.1908C12.9336 16.4995 13.4897 16.0796 13.812 15.7738C13.9921 15.6029 14.2329 15.4995 14.5 15.4995C15.0523 15.4995 15.5 15.9472 15.5 16.4995V17.4995H17.5V16.4995C17.5 14.8427 16.1569 13.4995 14.5 13.4995C13.7006 13.4995 12.9724 13.8135 12.4355 14.3229C12.3491 14.4048 12.2793 14.4543 12.2289 14.4808C12.2049 14.4934 12.1907 14.498 12.185 14.4995H11.815C11.8093 14.498 11.7952 14.4934 11.7711 14.4808C11.7207 14.4543 11.6509 14.4048 11.5645 14.3229C11.0276 13.8135 10.2994 13.4995 9.5 13.4995C7.84313 13.4995 6.5 14.8427 6.5 16.4995V17.4995H8.5V16.4995Z"}}]};

const Uncomfortable2FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'uncomfortable-2-filled',
    ref,
    icon: element,
  },
));

Uncomfortable2FilledIcon.displayName = 'Uncomfortable2FilledIcon';

export default Uncomfortable2FilledIcon;
